import React, { useState } from 'react';
import styles from './Sidebar.module.css';

interface SidebarProps {
    isHoliday?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isHoliday = false }) => {
    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (email) {
            setSubscribed(true);
            setTimeout(() => setSubscribed(false), 3000);
            setEmail('');
        }
    };

    return (
        <aside className={styles.sidebar}>
            <div className={`${styles.widget} ${isHoliday ? styles.holiday : ''}`}>
                <h3 className={styles.widgetTitle}>О блоге</h3>
                <p>
                    Добро пожаловать в самый темный (в смысле темы) блог! 🌙<br/>
                    Здесь мы делимся мыслями, которые слишком темны для обычных блогов.<br/>
                    Пока это как котята - мило, но еще не выросло!<br/>
                    Развиваемся по принципу "один компонент в день - и врач не нужен".<br/>
                    Заглушки - это не баги, это особенности дизайна! 🎨
                </p>
            </div>

            <div className={`${styles.widget} ${isHoliday ? styles.holiday : ''}`}>
                <h3 className={styles.widgetTitle}>Категории</h3>
                <ul className={styles.categoryList}>
                    <li>React (18+ только с ID)</li>
                    <li>JavaScript (Магия, а не язык)</li>
                    <li>CSS (Тёмная сторона силы)</li>
                    <li>Дизайн (Чтобы глаза не плакали)</li>
                    <li>Производительность (Быстрее только котики)</li>
                </ul>
            </div>

            <div className={`${styles.widget} ${isHoliday ? styles.holiday : ''}`}>
                <h3 className={styles.widgetTitle}>Подписка</h3>
                {subscribed ? (
                    <div style={{
                        background: 'rgba(76, 175, 80, 0.1)',
                        color: '#4caf50',
                        padding: '15px',
                        borderRadius: '10px',
                        textAlign: 'center',
                        border: '1px solid rgba(76, 175, 80, 0.3)'
                    }}>
                        🎉 Ура! Теперь вы будете получать уведомления о новых постах (и котиках)!
                    </div>
                ) : (
                    <form className={styles.subscribeForm} onSubmit={handleSubmit}>
                        <input
                            type="email"
                            placeholder="Ваш email (не для спама, честно!)"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit">
                            Подписаться на магию ✨
                        </button>
                    </form>
                )}
            </div>
        </aside>
    );
};

export default Sidebar; 